const founders = [
  {
    imgProfile: 'https://djemclypbm8gi.cloudfront.net/static/about-us/james2.png',
    linkedin: 'https://www.linkedin.com/in/james-vuong-4634a0',
    name: 'James Vuong',
    role: 'Founder & CEO',
  },
  {
    imgProfile: 'https://djemclypbm8gi.cloudfront.net/static/about-us/giang2.png',
    linkedin: 'https://www.linkedin.com/in/giang-tran-0ab9bb35/',
    name: 'Giang Tran',
    role: 'Engineering Director',
  },
  {
    imgProfile: 'https://djemclypbm8gi.cloudfront.net/static/about-us/an.png',
    name: 'An Phan',
    role: 'Chief Accountant',
  },
  {
    imgProfile: 'https://djemclypbm8gi.cloudfront.net/static/about-us/trung.png',
    name: 'Trung Nguyen',
    role: 'Product Manager',
  },
  {
    imgProfile: 'https://djemclypbm8gi.cloudfront.net/static/about-us/calvinjr.png',
    name: 'Calvin Lam',
    role: 'Business Intelligence Manager',
  },
]
export default founders
